document.addEventListener("DOMContentLoaded", () => {
  initWorksTab();
});

// Rails Turbo環境で画面遷移した場合の対応
document.addEventListener("turbo:load", () => {
  initWorksTab();
});

function initWorksTab() {
  const tabButtons = document.querySelectorAll(".works-tab-nav .tab-btn");
  if (!tabButtons.length) return;

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      // 全ボタンからactiveクラスを外す
      tabButtons.forEach((b) => b.classList.remove("active"));
      // クリックされたボタンにactiveをつける
      btn.classList.add("active");

      // コンテンツの切り替え
      const targetSelector = btn.getAttribute("data-tab-target");
      const contents = document.querySelectorAll(".works-sec .tab-content");

      contents.forEach((content) => content.classList.remove("active"));
      const targetContent = document.querySelector(targetSelector);
      if (targetContent) {
        targetContent.classList.add("active");
      }
    });
  });
}